import styled from 'styled-components';
import {TimelineItem as TimelineItemUI} from '@material-ui/lab';

export const TimelineItem = styled(TimelineItemUI)`
    &:first-of-type {
        padding-top: 20px
    }
`;